<template>
	<v-dialog v-model="modal" width="500" persistent>
		<ValidationObserver ref="refundObs" v-slot="{ invalid }">
			<v-form>
				<v-card>
					<v-card-title class="grey lighten-2">
						Add Refund #{{ value.code }}
					</v-card-title>

					<v-card-text>
						<v-container grid-list-md>
							<v-layout row wrap>
								<v-flex xs12>
									<ValidationProvider
										name="original_amount"
										rules="required"
										v-slot="{ errors }"
									>
										<v-text-field
											label="Original Amount"
											readonly
											v-model="refund.original_amount"
											:error-messages="errors"
										></v-text-field>
									</ValidationProvider>
								</v-flex>

								<v-flex xs12>
									<ValidationProvider
										name="refunded_amount"
										rules="required"
										v-slot="{ errors }"
									>
										<v-text-field
											label="Refunded Amount"
											v-model="refund.refunded_amount"
											:error-messages="errors"
										></v-text-field>
									</ValidationProvider>
								</v-flex>

								<v-flex xs12>
									<ValidationProvider
										name="reason"
										rules="required"
										v-slot="{ errors }"
									>
										<v-textarea
											label="Reason"
											v-model="refund.reason"
											:error-messages="errors"
										></v-textarea>
									</ValidationProvider>
								</v-flex>
							</v-layout>
						</v-container>
					</v-card-text>

					<v-divider></v-divider>

					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="error" text @click="closeRefund()">
							Close
						</v-btn>
						<v-btn
							color="primary"
							:disabled="invalid"
							:loading="refund.processing"
							@click.native="submitRefund()"
						>
							Submit
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</ValidationObserver>
	</v-dialog>
</template>

<script>
export default {
	props: ["value"],

	data() {
		return {
			modal: false,
			refund: this.$inertia.form({
				order_id: this.value.id,
				original_amount: this.value.available_refund_amount,
				refunded_amount: 0,
				reason: "",
			}),
		};
	},

	watch: {
		value: {
			handler(newValue) {
				this.refund = this.$inertia.form({
					order_id: newValue.id,
					original_amount: newValue.available_refund_amount,
					refunded_amount: 0,
					reason: "",
				});
			},
			deep: true,
		},
	},

	methods: {
		openRefund() {
			this.modal = true;
		},

		closeRefund() {
			this.modal = false;
		},

		submitRefund() {
			this.refund.post(
				this.$route("tenant.refunds.store", {
					tenant: this.$page.props.tenant.id,
				}),
				{
					preserveState: (page) =>
						page.props.flash.error ||
						Object.keys(page.props.errors).length > 0,
					preserveScroll: true,
					onSuccess: (page) => {
						this.modal = false;
					},
				}
			);
		},
	},
};
</script>